module.exports = __webpack_public_path__ + "static/media/close-icon-without-bg.3fc3efe3.svg";